export interface HomeStat {
  id: string;
  value: string;
  suffix: string;
  labelRu: string;
  labelKk: string;
  labelEn: string;
}

export interface HomeDiscipline {
  id: string;
  icon: string;
  image: string;
  titleRu: string;
  titleKk: string;
  titleEn: string;
  descriptionRu: string;
  descriptionKk: string;
  descriptionEn: string;
}

export interface HomeGoal {
  id: string;
  textRu: string;
  textKk: string;
  textEn: string;
}

export interface HomeTask {
  id: string;
  icon: string;
  titleRu: string;
  titleKk: string;
  titleEn: string;
  descriptionRu: string;
  descriptionKk: string;
  descriptionEn: string;
}

export interface HomeEvent {
  id: string;
  date: string;
  image: string;
  titleRu: string;
  titleKk: string;
  titleEn: string;
  locationRu: string;
  locationKk: string;
  locationEn: string;
  descriptionRu: string;
  descriptionKk: string;
  descriptionEn: string;
  guestsRu: string;
  guestsKk: string;
  guestsEn: string;
  equipmentRu: string;
  equipmentKk: string;
  equipmentEn: string;
}

export const homeStats: HomeStat[] = [
  { value: '123', suffix: '+', labelRu: 'Завоевание наград', labelKk: 'Жүлделі орындар', labelEn: 'Awards won', id: 'stat-awards' },
  { value: '1,476', suffix: '+', labelRu: 'Активный участник', labelKk: 'Белсенді қатысушылар', labelEn: 'Active members', id: 'stat-members' },
  { value: '2', suffix: '', labelRu: 'Медали UAE SWAT Challenge 2026', labelKk: 'UAE SWAT Challenge 2026 медальдары', labelEn: 'UAE SWAT Challenge 2026 Medals', id: 'stat-swat' },
  { value: '8', suffix: '+', labelRu: 'Лет на службе спорту', labelKk: 'Спортқа қызмет ету жылдары', labelEn: 'Years serving sports', id: 'stat-years' },
];

export const homeDisciplines: HomeDiscipline[] = [
  {
    id: 'disc-shooting',
    titleRu: 'Полоса препятствий',
    titleKk: 'Кедергілер жолағы',
    titleEn: 'Obstacle Course',
    descriptionRu: 'Преодоление военизированной полосы препятствий — стены, барьеры, сети и ямы в условиях максимальной нагрузки',
    descriptionKk: 'Әскерилендірілген кедергілер жолағын еңсеру — қабырғалар, тосқауылдар, торлар мен шұңқырлар',
    descriptionEn: 'Overcoming military obstacle courses — walls, barriers, nets, and trenches under intense physical loads',
    icon: 'ri-run-line',
    image: 'https://readdy.ai/api/search-image?query=Kazakh%20East%20Asian%20Mongoloid%20young%20man%20athlete%20with%20broad%20cheekbones%20almond%20eyes%20short%20black%20hair%20in%20military%20camouflage%20uniform%20climbing%20over%20tall%20wooden%20wall%20obstacle%20competition%20outdoor%20sandy%20arena%20intense%20physical%20effort%20arms%20muscles%20dramatic%20cinematic%20warm%20amber%20light%20dark%20shadows%20muted%20olive%20earth%20tones%20no%20text%20no%20flags%20no%20western%20caucasian%20faces&width=800&height=500&seq=disc-kz-wall-v4&orientation=landscape&nocache=true',
  },
  {
    id: 'disc-bullseye',
    titleRu: 'Переноска груза',
    titleKk: 'Жүк тасу',
    titleEn: 'Load Carry',
    descriptionRu: 'Транспортировка тяжёлых предметов на дистанцию — брёвна, шины, снаряжение, раненый боец',
    descriptionKk: 'Ауыр заттарды қашықтыққа тасымалдау — бөренелер, шиналар, жабдықтар, жаралы жауынгер',
    descriptionEn: 'Transporting heavy equipment over distances — logs, tires, gear, and casualty evacuation',
    icon: 'ri-box-3-line',
    image: 'https://readdy.ai/api/search-image?query=Team%20of%20Kazakh%20East%20Asian%20Mongoloid%20young%20men%20athletes%20with%20broad%20cheekbones%20almond%20eyes%20short%20black%20hair%20in%20military%20camouflage%20uniforms%20carrying%20massive%20heavy%20log%20on%20shoulders%20together%20outdoor%20sandy%20desert%20competition%20arena%20synchronized%20effort%20strained%20faces%20cinematic%20low%20angle%20warm%20amber%20golden%20light%20dust%20muted%20earth%20tones%20no%20text%20no%20flags%20no%20western%20caucasian%20faces&width=800&height=500&seq=disc-kz-log-v4&orientation=landscape&nocache=true',
  },
  {
    id: 'disc-clay',
    titleRu: 'Переворот шины',
    titleKk: 'Шинаны аудару',
    titleEn: 'Tire Flip',
    descriptionRu: 'Классическое силовое упражнение SWAT Challenge — переворот боевой шины на время',
    descriptionKk: 'SWAT Challenge классикалық күш жаттығуы — ауыр жауынгерлік шинаны уақытқа аудару',
    descriptionEn: 'Classic SWAT Challenge power exercise — flipping massive tactical truck tires against the clock',
    icon: 'ri-refresh-line',
    image: 'https://readdy.ai/api/search-image?query=Kazakh%20East%20Asian%20Mongoloid%20young%20man%20athlete%20with%20broad%20cheekbones%20almond%20eyes%20short%20black%20hair%20in%20military%20camouflage%20uniform%20flipping%20massive%20heavy%20truck%20tire%20outdoor%20sandy%20arena%20low%20squat%20position%20full%20body%20effort%20powerful%20muscles%20cinematic%20dramatic%20warm%20amber%20golden%20light%20dust%20haze%20muted%20olive%20sand%20tones%20no%20text%20no%20flags%20no%20western%20caucasian%20faces&width=800&height=500&seq=disc-kz-tire-v4&orientation=landscape&nocache=true',
  },
  {
    id: 'disc-medicine',
    titleRu: 'Тактическая медицина',
    titleKk: 'Тактикалық медицина',
    titleEn: 'Tactical Medicine',
    descriptionRu: 'Переноска пострадавшего и оказание первой помощи в полевых условиях с хронометражом',
    descriptionKk: 'Далалық жағдайда зардап шегушіні тасымалдау және алғашқы медициналық көмек көрсету',
    descriptionEn: 'Field casualty evacuation and timed tactical emergency combat care exercises',
    icon: 'ri-first-aid-kit-line',
    image: 'https://readdy.ai/api/search-image?query=Kazakh%20East%20Asian%20Mongoloid%20young%20man%20athlete%20with%20broad%20cheekbones%20almond%20eyes%20short%20black%20hair%20in%20military%20camouflage%20uniform%20carrying%20another%20soldier%20in%20fireman%20carry%20over%20shoulders%20running%20outdoor%20sandy%20competition%20arena%20intense%20speed%20dramatic%20cinematic%20warm%20amber%20light%20muted%20olive%20sand%20tones%20no%20text%20no%20flags%20no%20western%20caucasian%20faces&width=800&height=500&seq=disc-kz-carry-v4&orientation=landscape&nocache=true',
  },
  {
    id: 'disc-tactical',
    titleRu: 'Командные испытания',
    titleKk: 'Командалық сындар',
    titleEn: 'Team Challenge',
    descriptionRu: 'Синхронные командные упражнения — координация, взаимодействие, единое выполнение задачи',
    descriptionKk: 'Синхронды командалық жаттығулар — үйлестіру, өзара іс-қимыл, тапсырманы бірлесе орындау',
    descriptionEn: 'Synchronized team drills — coordination, tactical movement, and unified mission execution',
    icon: 'ri-team-line',
    image: 'https://readdy.ai/api/search-image?query=Group%20of%20Kazakh%20East%20Asian%20Mongoloid%20young%20men%20athletes%20with%20broad%20cheekbones%20almond%20eyes%20short%20black%20hair%20in%20matching%20military%20camouflage%20tactical%20uniforms%20standing%20in%20perfect%20synchronized%20military%20formation%20outdoor%20competition%20arena%20proud%20strong%20disciplined%20posture%20cinematic%20dramatic%20lighting%20warm%20amber%20tones%20dust%20haze%20dark%20background%20no%20text%20no%20flags%20no%20western%20caucasian%20faces&width=800&height=500&seq=disc-kz-team-v4&orientation=landscape&nocache=true',
  },
  {
    id: 'disc-obstacle',
    titleRu: 'Скоростной марш-бросок',
    titleKk: 'Жылдам марш-бросок',
    titleEn: 'Tactical Sprint',
    descriptionRu: 'Забег с полным тактическим снаряжением — скорость, выносливость, работа в команде',
    descriptionKk: 'Толық тактикалық жабдықпен жүгіру — жылдамдық, төзімділік, командалық жұмыс',
    descriptionEn: 'Full gear tactical sprint — testing speed, endurance, and squad cohesion under time pressure',
    icon: 'ri-footprint-line',
    image: 'https://readdy.ai/api/search-image?query=Kazakh%20East%20Asian%20Mongoloid%20young%20men%20athletes%20with%20broad%20cheekbones%20almond%20eyes%20short%20black%20hair%20sprinting%20in%20full%20tactical%20military%20gear%20helmets%20vests%20outdoor%20sandy%20competition%20arena%20low%20angle%20dramatic%20shot%20motion%20blur%20cinematic%20warm%20golden%20amber%20light%20dust%20cloud%20muted%20olive%20graphite%20tones%20no%20text%20no%20flags%20no%20western%20caucasian%20faces&width=800&height=500&seq=disc-kz-sprint-v4&orientation=landscape&nocache=true',
  },
];

export const homeGoals: HomeGoal[] = [
  {
    id: 'goal-1',
    textRu: 'Организация и подготовка членов Федерации, сотрудников охраны, телохранителей, специалистов инкасационных служб, сотрудников силовых структур по безопасному обращению с оружием и спортивно-тактико-специальной подготовке',
    textKk: 'Федерация мүшелерін, күзет қызметкерлерін, оққағарларды, инкассация мамандарын, күштік құрылымдардың қызметкерлерін қаруды қауіпсіз қолдануға және спорттық-тактикалық арнайы дайындыққа үйрету',
    textEn: 'Training Federation members, security personnel, bodyguards, cash transit specialists, and law enforcement in safe firearm handling and specialized tactical sports preparation',
  },
  {
    id: 'goal-2',
    textRu: 'Организация спортивно военно-тактических игр и соревнований',
    textKk: 'Спорттық әскери-тактикалық ойындар мен жарыстарды ұйымдастыру',
    textEn: 'Organizing sports military-tactical games and competitive tournaments',
  },
  {
    id: 'goal-3',
    textRu: 'Организация и обучение стрелковому спорту на профессиональном уровне',
    textKk: 'Кәсіби деңгейде ату спортын ұйымдастыру және оқыту',
    textEn: 'Professional shooting sports education and training organization',
  },
  {
    id: 'goal-4',
    textRu: 'Организация и обучение спортивной практической и пулевой стрельбе',
    textKk: 'Спорттық практикалық және оқпен атуды ұйымдастыру және оқыту',
    textEn: 'Organizing and training in practical shooting and marksmanship',
  },
  {
    id: 'goal-5',
    textRu: 'Организация и обучение спортивной стендовой стрельбе',
    textKk: 'Спорттық стендтік атуды ұйымдастыру және оқыту',
    textEn: 'Organizing and training in clay target and trap shooting',
  },
  {
    id: 'goal-6',
    textRu: 'Обучение оказанию первой доврачебной помощи и тактической медицине',
    textKk: 'Дәрігерге дейінгі алғашқы көмек көрсетуді және тактикалық медицинаны оқыту',
    textEn: 'Training in first aid and field tactical combat medicine',
  },
];

export const homeTasks: HomeTask[] = [
  {
    id: 'task-competitions',
    icon: 'ri-trophy-line',
    titleRu: 'Организация соревнований',
    titleKk: 'Жарыстарды ұйымдастыру',
    titleEn: 'Tournament Organization',
    descriptionRu: 'Проведение соревнований по военно-прикладным видам спорта для спортсменов различных уровней, от любителей до профессионалов',
    descriptionKk: 'Әуесқойлардан бастап кәсіпқойларға дейінгі әртүрлі деңгейдегі спортшылар үшін жарыстар өткізу',
    descriptionEn: 'Hosting military applied sports competitions for athletes ranging from amateurs to elite professionals',
  },
  {
    id: 'task-training',
    icon: 'ri-compass-3-line',
    titleRu: 'Тренировочная работа',
    titleKk: 'Жаттығу жұмыстары',
    titleEn: 'Training Programs',
    descriptionRu: 'Поддержка и организация тренировочных программ, подготовка тренеров, создание условий для профессионального тренинга',
    descriptionKk: 'Жаттығу бағдарламаларын қолдау және ұйымдастыру, бапкерлерді дайындау, кәсіби тренингтерге жағдай жасау',
    descriptionEn: 'Supporting training programs, coaching development, and establishing facilities for high-performance training',
  },
  {
    id: 'task-infrastructure',
    icon: 'ri-building-3-line',
    titleRu: 'Развитие инфраструктуры',
    titleKk: 'Инфрақұрылымды дамыту',
    titleEn: 'Infrastructure Development',
    descriptionRu: 'Помощь в создании и совершенствовании инфраструктуры для проведения тренировок и соревнований, включая полигоны и спортивные залы',
    descriptionKk: 'Полигондар мен спорт залдарын қоса алғанда, жаттығулар мен жарыстар өткізуге арналған инфрақұрылымды құруға көмектесу',
    descriptionEn: 'Building and enhancing training grounds, shooting ranges, and tactical sports complexes',
  },
];

export const homeMainTasksKk = [
  'Патриоттық тәрбие беру, жастардың бойында азаматтық пен патриотизмді ең маңызды рухани-адамгершілік құндылық ретінде дамыту',
  'Азаматтардың спортқа, дене дамуына және өзін-өзі жетілдіруге деген қызығушылығын арттыру',
  'Салауатты өмір салты дағдыларын қалыптастыру және денсаулықты нығайту',
  'Халықаралық жарыстар өткізу арқылы халықаралық байланыстарды нығайту',
  'Өсіп келе жатқан ұрпақтың Отанға адалдығын, Отанға қызмет етуге дайындығын қалыптастыру',
  'Тиімді жаттығу процесіне жағдай жасау, бапкерлер мен нұсқаушыларды дайындауды ұйымдастыру',
];

export const homeMainTasksRu = [
  'Патриотическое воспитание, развитие у молодежи гражданственности, патриотизма как важнейших духовно-нравственных и социальных ценностей',
  'Развитие интереса граждан к спорту, физическому развитию и совершенствованию',
  'Укрепление здоровья на основе знаний смежных наук, формирование навыков здорового образа жизни',
  'Укрепление международных связей посредством проведения международных соревнований',
  'Формирование у подрастающего поколения верности Родине, готовности к служению Отечеству, уверенности в своих силах',
  'Создание условий для эффективного тренировочного процесса, организация подготовки тренерских кадров и инструкторов, повышение квалификации спортивных судей',
];

export const homeMainTasksEn = [
  'Patriotic education, fostering civic duty and patriotism among youth as essential spiritual and moral values',
  'Promoting public engagement in physical culture, athletic progress, and self-improvement',
  'Promoting healthy lifestyle habits, physical resilience, and wellness',
  'Strengthening international sports partnerships by staging global competitions',
  'Cultivating dedication, readiness to serve the homeland, and self-confidence in young generations',
  'Creating high-standard training infrastructure, developing certified instructors, and upgrading sports referee qualifications',
];

export const homeEvents: HomeEvent[] = [
  {
    id: 'event-1',
    date: '15.08.2025',
    image: 'https://readdy.ai/api/search-image?query=UAE%20Dubai%20outdoor%20competition%20arena%20international%20SWAT%20Challenge%20championship%20Kazakh%20East%20Asian%20Mongoloid%20young%20men%20athletes%20broad%20cheekbones%20almond%20eyes%20in%20military%20camouflage%20uniforms%20competing%20at%20finish%20line%20celebrating%20victory%20cinematic%20wide%20dramatic%20warm%20golden%20amber%20light%20dust%20haze%20premium%20sports%20photography%20no%20text%20no%20western%20caucasian%20faces&width=800&height=500&seq=event-kz-swat-v4&orientation=landscape&nocache=true',
    titleRu: 'UAE SWAT Challenge — Казахстанская команда',
    titleKk: 'UAE SWAT Challenge — Қазақстан командасы',
    titleEn: 'UAE SWAT Challenge — Kazakhstan Team',
    locationRu: 'Дубай, ОАЭ',
    locationKk: 'Дубай, БАӘ',
    locationEn: 'Dubai, UAE',
    descriptionRu: 'Казахстанская команда федерации на международном соревновании UAE SWAT Challenge — одном из самых престижных тактических чемпионатов мира.',
    descriptionKk: 'Федерацияның Қазақстандық командасы халықаралық UAE SWAT Challenge жарысында — әлемдегі ең беделді тактикалық чемпионаттардың бірі.',
    descriptionEn: 'The Federation\'s national team competing at the UAE SWAT Challenge — one of the world\'s premier international tactical tournaments.',
    guestsRu: '50 участников',
    guestsKk: '50 қатысушы',
    guestsEn: '50 participants',
    equipmentRu: 'Тактическая форма, защитный шлем, жилет',
    equipmentKk: 'Тактикалық форма, дулыға, жилет',
    equipmentEn: 'Tactical uniform, helmet, vest',
  },
  {
    id: 'event-2',
    date: '22.09.2025',
    image: 'https://readdy.ai/api/search-image?query=Kazakhstan%20national%20military%20applied%20sports%20championship%20outdoor%20arena%20Kazakh%20East%20Asian%20Mongoloid%20young%20men%20athletes%20broad%20cheekbones%20almond%20eyes%20short%20black%20hair%20in%20military%20camouflage%20uniforms%20competing%20obstacle%20course%20climbing%20walls%20crawling%20under%20nets%20audience%20watching%20cinematic%20warm%20amber%20light%20dust%20muted%20olive%20tones%20no%20text%20no%20western%20caucasian%20faces&width=800&height=500&seq=event-kz-champ-v4&orientation=landscape&nocache=true',
    titleRu: 'Открытый чемпионат по тактическому многоборью',
    titleKk: 'Тактикалық көпсайыс бойынша ашық чемпионат',
    titleEn: 'Open Tactical All-Around Championship',
    locationRu: 'Учебный центр Федерации, Шымкент',
    locationKk: 'Федерацияның оқу орталығы, Шымкент',
    locationEn: 'Federation Training Center, Shymkent',
    descriptionRu: 'Национальный чемпионат по тактическому многоборью — препятствия, силовые упражнения, переноска груза и командные этапы.',
    descriptionKk: 'Тактикалық көпсайыс бойынша ұлттық чемпионат — кедергілер, күш жаттығулары, жүк тасу және командалық кезеңдер.',
    descriptionEn: 'National tactical all-around championship featuring obstacle courses, power challenges, load carries, and team stages.',
    guestsRu: '30 команд',
    guestsKk: '30 команда',
    guestsEn: '30 teams',
    equipmentRu: 'Тактическая форма, шлем, защита тела',
    equipmentKk: 'Тактикалық форма, дулыға, дене қорғанысы',
    equipmentEn: 'Tactical gear, helmet, body armor',
  },
  {
    id: 'event-3',
    date: '05.10.2025',
    image: 'https://readdy.ai/api/search-image?query=Group%20of%20Kazakh%20East%20Asian%20Mongoloid%20young%20men%20athletes%20with%20broad%20cheekbones%20almond%20eyes%20short%20black%20hair%20in%20matching%20military%20camouflage%20tactical%20uniforms%20standing%20in%20perfect%20synchronized%20military%20formation%20outdoor%20competition%20arena%20proud%20strong%20disciplined%20posture%20cinematic%20dramatic%20lighting%20warm%20amber%20tones%20dust%20haze%20dark%20background%20no%20text%20no%20flags%20no%20western%20caucasian%20faces&width=800&height=500&seq=disc-kz-team-v4&orientation=landscape&nocache=true',
    titleRu: 'Командные военно-тактические игры',
    titleKk: 'Командалық әскери-тактикалық ойындар',
    titleEn: 'Team Military Tactical Games',
    locationRu: 'Полевой учебный лагерь, Шымкент',
    locationKk: 'Далалық оқу лагері, Шымкент',
    locationEn: 'Field Training Camp, Shymkent',
    descriptionRu: 'Командные тактические упражнения с элементами координации, дисциплины и стратегического планирования.',
    descriptionKk: 'Үйлестіру, тәртіп және стратегиялық жоспарлау элементтері бар командалық тактикалық жаттығулар.',
    descriptionEn: 'Competitive team tactical exercises focusing on squad coordination, discipline, and field maneuver strategy.',
    guestsRu: '10 команд',
    guestsKk: '10 команда',
    guestsEn: '10 teams',
    equipmentRu: 'Комбинезон, защита тела, защитный шлем',
    equipmentKk: 'Комбинезон, дене қорғанысы, дулыға',
    equipmentEn: 'Tactical overall, body armor, helmet',
  },
];

export const federationContacts = {
  addressRu: 'Республика Казахстан, город Шымкент, Енбекшинский район, микрорайон Шапагат, улица Жанажол, дом 16',
  addressKk: 'Қазақстан Республикасы, Шымкент қаласы, Еңбекші ауданы, Шапағат шағынауданы, Жаңажол көшесі, 16 үй',
  addressEn: '16 Zhanazhol Str., Shapagat microdistrict, Enbekshi district, Shymkent city, Republic of Kazakhstan',
  email: 'Info@militarysport.kz',
  phone: '+7 701 088 8808',
  hoursRu: 'Каждый день с 09:00 утра до 19:00 вечера',
  hoursKk: 'Күн сайын 09:00-ден 19:00-ге дейін',
  hoursEn: 'Every day from 09:00 AM to 07:00 PM',
};

export const federationSocial = {
  instagram: 'https://www.instagram.com/militarysport.kz',
  youtube: 'https://www.youtube.com/watch?v=4SFhELh3xQM',
};